import { TextButton } from 'ui/button';
import { StyledHeader, StyledHeaderLeft, StyledHeaderRight } from './JourneyAssistDialog.styled';

export const LOADING_TEST_ID = 'loading';

export const LoadingHeader = ({ onCancel }: { onCancel: () => void }) => {
  return (
    <StyledHeader shiftRight data-test={LOADING_TEST_ID}>
      <StyledHeaderLeft>Generating</StyledHeaderLeft>
      <StyledHeaderRight>
        <TextButton onClick={onCancel}>Cancel</TextButton>
      </StyledHeaderRight>
    </StyledHeader>
  );
};
